<div class="viol">
    <rask-button 
        color="secondary"
        (click)="sendViol3()"
        [disabled]="!canSend()">
    @if (showButtonSpinner) {
        <rask-busy-spinner
            size="1">
        </rask-busy-spinner>
        }
        {{ buttonText }}
    </rask-button>

  @if (!isSendInProgress) {
    <rask-icon icon="fas fa-info-circle">
      <b>För att knappen ska tändas upp krävs att:</b>
      @for (rule of buttonConfig.activeRules; track rule.text) {
        <div class="skicka-vo-knapp-info">
          <i [class]="setValidationIIcon(rule.validationFunction())"
            [style.color]="setValidationColor(rule.validationFunction())"></i>
          {{ rule.text }}
        </div>
      }
    </rask-icon>
  }
  @if (senastSkickad) {
    <p class="float-start col-12 vo-sent-text">Senast skickad till VIOL: {{senastSkickad }}</p>
  }
</div>
